import React, { Component } from 'react';
import ListSelector from 'components/ListSelector';
import { mixin, RefluxMixin } from 'Util';
import GroupStore from 'stores/Group';
import GroupActions from 'actions/Group';

export default class GroupSelector extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStore(GroupStore);
  }

  componentDidMount() {
    GroupActions.findBuildable();
  }

  reset() {
    this.refs.selector.reset();
  }

  getSelected() {
    return this.refs.selector.getSelected();
  }

  render() {
    return (
      <ListSelector
        ref="selector"
        searchHint="Choose Groups"
        {...this.props}
        items={this.state.buildable}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/GroupSelector.js